import { render, staticRenderFns } from "./askAndReply.vue?vue&type=template&id=2ea9b7c7&scoped=true"
import script from "./askAndReply.vue?vue&type=script&lang=js"
export * from "./askAndReply.vue?vue&type=script&lang=js"
import style0 from "./askAndReply.vue?vue&type=style&index=0&id=2ea9b7c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9b7c7",
  null
  
)

export default component.exports